<template>
  <div class="flex gap-3">
    <a v-for="(item, i) in items" :key="i" :href="item.link" target="_blank">
      <component :is="item.icon" class="w-5 h-5 transition hover:scale-105" />
    </a>
    <button class="p-0 m-0" @click="handleShare">
      <IconLink45Deg class="w-5 h-5" />
    </button>
  </div>
</template>
<script lang="ts">
import IconFacebook from '~/components/icons/IconFacebook.vue'
import { IconLinkedIn } from '#components'
import IconPinterest from '~/components/icons/IconPinterest.vue'
import IconLink45Deg from '~/components/icons/IconLink45Deg.vue'

export default defineComponent({
  name: 'MagazineSocialIcons',
  components: { IconLink45Deg },
  props: {
    image: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    seeMoreSrc: {
      type: String,
      default: '',
    },
    titleBelowImage: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const fullLocalizedUrl = useFullLocalizedUrl(true)
    const $route = useRoute()
    const items = [
      {
        icon: IconFacebook,
        link: `https://www.facebook.com/sharer.php?u=${fullLocalizedUrl(
          $route.fullPath
        )}`,
      },
      {
        icon: IconLinkedIn,
        link: `https://linkedin.com/shareArticle?url=${fullLocalizedUrl(
          $route.fullPath
        )}`,
      },
      {
        icon: IconPinterest,
        link: `http://pinterest.com/pin/create/button/?url=${fullLocalizedUrl(
          $route.fullPath
        )}`,
      },
    ]
    return {
      fullLocalizedUrl,
      items,
      fullPath: $route.fullPath,
    }
  },
  head: {},
  methods: {
    handleShare() {
      const share = window.navigator.share || navigator.share

      if (!share) {
        console.warn("Your browser doesn't support the Web Share API.")
        return
      }

      const data = {
        url: this.fullLocalizedUrl(this.fullPath),
        title: this.$t('general.titles.base'),
      }

      share(data).catch((error) => {
        console.error(`Error: ${error.message}`)
      })
    },
  },
})
</script>
